export default "<template>\r\n  <v-row justify=\"center\" align=\"center\">\r\n    <v-chip :ripple=\"false\">Default</v-chip>\r\n  </v-row>\r\n</template>\r\n";